export default "__VITE_ASSET__dpTBp52C__"